import React, { Component } from 'react';

import { data } from './data/data';

import WelcomeScreen from './components/other/welcomeScreen';
import MainButton from './components/buttons/mainButton';
import AppLoader from './components/other/appLoader';
import BotMessage from './components/messages/botMessage';
import UserMessage from './components/messages/userMessage';
import CheckboxText from './components/inputs/checkboxText';
import CompanyName from './components/inputs/companyName';
import TextOnly from './components/inputs/textOnly';
import GenderSelect from './components/inputs/genderSelect';
import RadioButtonText from './components/inputs/radioButtonText';
import Results from './components/results/results';

import { de, en } from './translations';

import { contactRef } from './config/firebase';

import './App.css'


class App extends Component {

  state = {

    group: '', // for A/B testing --> use parameter "group" in URL
    locale: '', // for internationalization --> use parameter "locale" in URL (fallback is 'en' if not specified)

    step: 0,
    appLoading: false,
    companyFieldInput: '',
    productFieldInput: '',
    otherFieldInput: '',
    goalsSaved: false,
    industriesSaved: false,
    ageRangesSaved: false,
    genderSaved: false,
    else: '',
    textInputType: '',
    maxAgeRanges: '',
    afterSavePage: '',

    companyName: '',
    companyUrl: '',
    companyLogo: '',
    productName: '',
    goals: [],
    industries: [],
    ageRanges: [],
    gender: [],
    other: '',
    weightedScores: {},
    goalScores: {},
    industryScores: {},
    ageScores: {},
    recommendation: {
      topOne: '',
      topTwo: '',
    },
    email: '',
    phone: '',
    optin: false,
  }


  //sets app settings based on parameters in URL
  setSettings(location) {
    const url = new URL(location)

    const group = url.searchParams.get('group') || ''
    const locale = url.searchParams.get('locale') || 'en' // 'en' is standard fallback language

    this.setState({
      group, locale
    })
  }

  //selects correct translation function
  returnTranslation() {

    const obj = {
      product: this.state.productName,
      industries: this.state.industries,
      goals: this.state.goals,
      recommendation: this.state.recommendation,
    }

    switch(this.state.locale) {
      case 'en':
        return en(obj)
      case 'de':
        return de(obj)
      default:
        return en(obj)  // 'en' is standard fallback language
    }
  }

  triggerNext(time) {
    this.timer = setTimeout((time) => {
      this.setState({step: this.state.step + 1})
    }, time)
  }

  handleCompanySubmit(company) {
    if (this.state.companyFieldInput.length > 0) {
      this.setState({
        companyName: company.name,
        companyUrl: company.domain,
        companyLogo: company.logo,
      })
      this.triggerNext(859)
    }
  }

  handleProductSubmit() {
    if (this.state.productFieldInput.length > 0) {
      this.setState({
        productName: this.state.productFieldInput,
        productFieldInput: '',
      })

      this.triggerNext(859)
    }
  }

  handleOtherSubmit() {
    if (this.state.otherFieldInput.length > 0) {
      this.setState({
        other: this.state.otherFieldInput,
        otherFieldInput: '',
      })

      this.triggerNext(859)
    }
  }

  handleGoalSubmit() {
    this.setState({goalsSaved: true})
    this.triggerNext(1385)
  }

  handleIndustrySubmit() {
    this.setState({industriesSaved: true})
    this.triggerNext(985)
  }

  handleAgeRangeSubmit() {
    this.setState({ageRangesSaved: true})
    this.triggerNext(1485)
  }

  handleGenderSubmit() {
    this.setState({genderSaved: true})
    this.triggerNext(879)
  }

  setGoals(selectedGoal) {
    this.setState({textInputType: ""})
    clearTimeout(this.timer)
    if (!this.state.goals.includes(selectedGoal) /*&& this.state.goals.length <= 3*/) {
      this.setState(prevState => ({
        goals: [...prevState.goals, selectedGoal],
        goalsSaved: false,
        step: 8,
        industries: [],
        ageRanges: [],
        gender: [],
        other: '',
        else: '',
      }))
    } else {
      this.setState({
        goals: this.state.goals.filter(goal => goal !== selectedGoal),
        goalsSaved: false,
        step: 8,
        industries: [],
        ageRanges: [],
        gender: [],
        other: '',
        else: '',
      })
    }
  }

  setIndustries(selectedIndustry) {
    this.setState({textInputType: ""})
    clearTimeout(this.timer)
    if (!this.state.industries.includes(selectedIndustry) && this.state.industries.length <= 1) {
      this.setState(prevState => ({
        industries: [...prevState.industries, selectedIndustry],
        industriesSaved: false,
        step: 10,
        ageRanges: [],
        gender: [],
        other: '',
        else: '',
      }))
    } else {
      this.setState({
        industries: this.state.industries.filter(industry => industry !== selectedIndustry),
        industriesSaved: false,
        step: 10,
        ageRanges: [],
        gender: [],
        other: '',
        else: '',
      })
    }
  }

  setAgeRanges(selectedAgeRange) {
    this.setState({textInputType: ""})
    clearTimeout(this.timer)
    if (!this.state.ageRanges.includes(selectedAgeRange)) {
      this.setState(prevState => ({
        ageRanges: [...prevState.ageRanges, selectedAgeRange],
        ageRangesSaved: false,
        step: 12,
        gender: [],
        other: '',
        else: '',
      }))
    } else {
      this.setState({
        ageRanges: this.state.ageRanges.filter(ageRange => ageRange !== selectedAgeRange),
        ageRangesSaved: false,
        step: 12,
        gender: [],
        other: '',
        else: '',
      })
    }
  }

  setGender(selectedGender) {
    this.setState({textInputType: ""})
    clearTimeout(this.timer)
    if (!this.state.gender.includes(selectedGender)) {
      this.setState(prevState => ({
        gender: [...prevState.gender, selectedGender],
        genderSaved: false,
        step: 14,
        other: '',
        else: '',
      }))
    } else {
      this.setState({
        gender: this.state.gender.filter(gender => gender !== selectedGender),
        genderSaved: false,
        step: 14,
        other: '',
        else: '',
      })
    }
  }

  setElse(value) {
    clearTimeout(this.timer)

    const newValue = value === "yes" //transforms yes/no from button to boolean

    this.setState({
      else: newValue,
      step: 16,
      other: '',
      otherFieldInput: '',
    })
    this.triggerNext(645)
  }

  progressBarWidth() {
    return this.state.step/18*100 + '%'
  }



  resetCompanyName() {
    this.setState({
      step: 3,
      companyName: '',
      companyUrl: '',
      companyLogo: '',
      productName: '',
      goals: [],
      industries: [],
      ageRanges: [],
      gender: [],
      other: '',
      else: '',
      textInputType: "company",
      companyFieldInput: '',
      productFieldInput: '',
      otherFieldInput: '',
    })

    clearTimeout(this.timer)
  }

  resetProductName() {
    this.setState({
      step: 6,
      productName: '',
      goals: [],
      industries: [],
      ageRanges: [],
      gender: [],
      other: '',
      else: '',
      textInputType: "product",
      productFieldInput: '',
      otherFieldInput: '',
    })

    clearTimeout(this.timer)
  }

  resetOther() {
    this.setState({
      step: 18,
      other: '',
      else: true,
      textInputType: "other",
      otherFieldInput: '',
    })

    clearTimeout(this.timer)
  }

  loadReportSequence() {
    this.setState({step: 1000})
  }

  textInputClass() {
    return (
      this.state.textInputType.length > 0
      ? "text-input-row text-input-row-visible"
      : "text-input-row"
    )
  }

  checkConversationEnd() {
    if ((this.state.else === false && this.state.step >= 17) ||
        (this.state.else === true && this.state.step >= 19)) {
      return true
    }
  }

  saveScoresToState(data) {

    const { weightedScores, goalScores, industryScores, ageScores, recommendation } = data

    this.setState({
      weightedScores, goalScores, industryScores, ageScores, recommendation
    })

  }

  scroll() {
    this.standardScroll.scrollIntoView()
  }

  saveResultsToDatabase() {

    const {
      companyName, companyUrl, productName, goals, industries,
      ageRanges, gender, other, weightedScores, goalScores, industryScores, ageScores, recommendation,
      email, phone, optin, group, locale
    } = this.state

    const createdAt = new Date().toISOString()

    const databaseObject = {
      createdAt, companyName, companyUrl, productName, goals, industries,
      ageRanges, gender, other, weightedScores, goalScores, industryScores, ageScores, recommendation,
      email, phone, optin, group, locale
    }

    contactRef.push().set((databaseObject),(error) => {
      error
        ? this.setState({afterSavePage: 'error'})
        : this.setState({afterSavePage: 'success'})
    })

  }

  componentDidMount() {
    this.setSettings(document.location.href)
    this.setState({maxAgeRanges: Object.keys(data.ageRanges).length})
  }

  componentDidUpdate() {

    //Manage autoscroll behaviour
      if (this.state.step > 0 && this.state.step < 1002) { this.standardScroll.scrollIntoView({behavior: "smooth"}) }
      if (this.state.step === 1002) { this.resultsScroll.scrollIntoView({behavior: "smooth", block: 'start'}) }

    //Load the report after end of conversation
      this.checkConversationEnd() && this.state.step < 1000 && this.loadReportSequence()

    //Manage the text input field visibility
      if (this.state.step === 3 && this.state.textInputType.length === 0) {this.setState({textInputType: "company"})}
      if (this.state.step === 4 && this.state.textInputType.length > 0) {this.setState({textInputType: ""})}
      if (this.state.step === 6 && this.state.textInputType.length === 0) {this.setState({textInputType: "product"})}
      if (this.state.step === 7 && this.state.textInputType.length > 0) {this.setState({textInputType: ""})}
      if (this.state.step === 18 && this.state.else === true && this.state.textInputType.length === 0) {this.setState({textInputType: "other"})}
      if (this.state.step >= 19 && this.state.textInputType.length > 0) {this.setState({textInputType: ""})}
  }

  render() {

    const copy = this.returnTranslation()

    return (
      <div className="no-select">

        <div className="legal-box">
          <a href={copy.legalBox.imprint.link} target="_blank" rel="noopener noreferrer">{copy.legalBox.imprint.title}</a>
          <a href={copy.legalBox.terms.link} target="_blank" rel="noopener noreferrer">{copy.legalBox.terms.title}</a>
          <a href={copy.legalBox.privacy.link} target="_blank" rel="noopener noreferrer">{copy.legalBox.privacy.title}</a>
        </div>

        <div
          style={{width: this.progressBarWidth()}}
          className="progress-bar"
        />

        {this.state.step === 0 &&
          <div className="welcome-container">

            {this.state.appLoading === false &&
              <div>
                <WelcomeScreen
                  action={() => this.setState({appLoading: true})}
                  copy={copy}
                />
              </div>
            }

            {this.state.appLoading === true &&
              <AppLoader
                triggerNext={() => this.triggerNext()}
                copy={copy}
              />
            }
          </div>
        }

        {this.state.step >= 1 &&
          <div className="conversation">

            {this.state.step >= 1 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m1.comment}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 2 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m2.comment}
                question={copy.botMessages.m2.question}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 3 && (this.state.companyFieldInput.length > 0 || this.state.companyName.length > 0)
              ? <UserMessage
                  fieldInput={this.state.companyFieldInput}
                  message={this.state.companyName}
                  companyName={this.state.companyName}
                  companyLogo={this.state.companyLogo}
                  onClick={() => this.resetCompanyName()}
                />
              : null
            }

            {this.state.step >= 4 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m4.comment}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 5 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m5.comment}
                question={copy.botMessages.m5.question}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 6 && (this.state.productFieldInput.length > 0 || this.state.productName.length > 0)
              ? <UserMessage
                  fieldInput={this.state.productFieldInput}
                  message={this.state.productName}
                  companyName={this.state.companyName}
                  companyLogo={this.state.companyLogo}
                  onClick={() => this.resetProductName()}
                />
              : null
            }

            {this.state.step >= 7 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m7.comment}
                question={copy.botMessages.m7.question}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 8 &&
              <CheckboxText
                setItems={(goal) => this.setGoals(goal)}
                selectedItems={this.state.goals}
                companyName={this.state.companyName}
                companyLogo={this.state.companyLogo}
                saveItems={() => this.handleGoalSubmit()}
                itemsSaved={this.state.goalsSaved}
                data={copy.inputs.goals}
                buttonText={copy.inputs.buttons.confirm}
              />
            }

            {this.state.step >= 9 && this.state.goals.length > 4 &&
              <BotMessage
                triggerNext={() => console.log('')}
                comment={copy.botMessages.m91.comment}
                question={copy.botMessages.m91.question}
                addon={copy.botMessages.m91.addon}
                scroll={() => this.scroll()}
                botName={copy.botName}
                button={<MainButton label={copy.botMessages.m91.button} action={() => window.open(copy.botMessages.m91.contactLink,"_self")}/>}
              />
            }

            {this.state.step >= 9 && this.state.goals.length <= 4 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m92.comment}
                question={copy.botMessages.m92.question}
                addon={copy.botMessages.m92.addon}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 10 &&
              <CheckboxText
                setItems={(industry) => this.setIndustries(industry)}
                selectedItems={this.state.industries}
                companyName={this.state.companyName}
                companyLogo={this.state.companyLogo}
                saveItems={() => this.handleIndustrySubmit()}
                itemsSaved={this.state.industriesSaved}
                data={copy.inputs.industries}
                buttonText={copy.inputs.buttons.confirm}
              />
            }

            {this.state.step >= 11 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m11.comment}
                question={copy.botMessages.m11.question}
                addon={copy.botMessages.m11.addon}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 12 &&
              <CheckboxText
                setItems={(ageRange) => this.setAgeRanges(ageRange)}
                selectedItems={this.state.ageRanges}
                companyName={this.state.companyName}
                companyLogo={this.state.companyLogo}
                saveItems={() => this.handleAgeRangeSubmit()}
                itemsSaved={this.state.ageRangesSaved}
                data={copy.inputs.ageRanges}
                buttonText={copy.inputs.buttons.confirm}
              />
            }

            {this.state.step >= 13 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                question={copy.botMessages.m13.question}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 14 &&
              <GenderSelect
                setItems={(gender) => this.setGender(gender)}
                selectedItems={this.state.gender}
                companyName={this.state.companyName}
                companyLogo={this.state.companyLogo}
                saveItems={() => this.handleGenderSubmit()}
                itemsSaved={this.state.genderSaved}
                data={copy.inputs.gender}
                buttonText={copy.inputs.buttons.confirm}
              />
            }

            {this.state.step >= 15 &&
              <BotMessage
                triggerNext={(time) => this.triggerNext(time)}
                comment={copy.botMessages.m15.comment}
                question={copy.botMessages.m15.question}
                addon={copy.botMessages.m15.addon}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 16 &&
              <div className="general-row">
                <RadioButtonText
                  data={copy.inputs.else}
                  companyName={this.state.companyName}
                  companyLogo={this.state.companyLogo}
                  setItem={(value) => this.setElse(value)}
                  selectedItem={this.state.else ? "yes" : ((this.state.else === "") ? "" : "no")}
                />
              </div>
            }

            {this.state.else === true &&
              <div>
                {this.state.step >= 17 &&
                  <BotMessage
                    triggerNext={(time) => this.triggerNext(time)}
                    comment={copy.botMessages.m17.comment}
                    question={copy.botMessages.m17.question}
                    scroll={() => this.scroll()}
                    botName={copy.botName}
                  />
                }

                {this.state.step >= 18 && (this.state.otherFieldInput.length > 0 || this.state.other.length > 0)
                  ? <UserMessage
                      fieldInput={this.state.otherFieldInput}
                      message={this.state.other}
                      companyName={this.state.companyName}
                      companyLogo={this.state.companyLogo}
                      onClick={() => this.resetOther()}
                    />
                  : null
                }
              </div>
            }







            {this.state.step >= 1000 &&
              <BotMessage
                triggerNext={() => this.triggerNext(2857)}
                comment={copy.botMessages.m1000.comment}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }

            {this.state.step >= 1001 &&
              <BotMessage
                triggerNext={() => this.triggerNext(2234)}
                comment={copy.botMessages.m1001.comment}
                question={copy.botMessages.m1001.question}
                scroll={() => this.scroll()}
                botName={copy.botName}
              />
            }


            <div ref={(ref) => this.resultsScroll = ref}></div>
            {this.state.step >= 1002 &&
              <div style={{display: 'flex', justifyContent: 'center'}}>
                <Results
                  triggerNext={() => this.triggerNext(2857)}
                  data={data}
                  appState={this.state}
                  saveScoresToState={(data) => this.saveScoresToState(data)}
                  toggleOptIn={() => this.setState({optin: !this.state.optin})}
                  updateEmail={(value) => this.setState({email: value})}
                  updatePhone={(value) => this.setState({phone: value})}
                  updateOptin={() => this.setState({optin: !this.state.optin})}
                  saveResultsToDatabase={() => this.saveResultsToDatabase()}
                  afterSavePage={this.state.afterSavePage}
                  copy={copy}
                />
              </div>
            }


            <div className={this.textInputClass()}>
              {this.state.textInputType === "company" &&
                <CompanyName
                  updateValue={(value) => this.setState({companyFieldInput: value})}
                  value={this.state.companyFieldInput}
                  handleCompanySubmit={(company) => this.handleCompanySubmit(company)}
                  placeholder={copy.placeholders.companyName}
                  scroll={() => this.scroll()}
                />
              }

              {this.state.textInputType === "product" &&
                <TextOnly
                  updateValue={(value) => this.setState({productFieldInput: value})}
                  value={this.state.productFieldInput}
                  handleValueSubmit={(value) => this.handleProductSubmit()}
                  placeholder={copy.placeholders.productName}
                  scroll={() => this.scroll()}
                />
              }

              {this.state.textInputType === "other" && this.state.else === true &&
                <TextOnly
                  updateValue={(value) => this.setState({otherFieldInput: value})}
                  value={this.state.otherFieldInput}
                  handleValueSubmit={(value) => this.handleOtherSubmit()}
                  placeholder={copy.placeholders.other}
                  scroll={() => this.scroll()}
                />
              }
            </div>
          </div>
        }



        {this.state.step >= 1 &&
          <div className="scroll-box" ref={(ref) => this.standardScroll = ref} />
        }

      </div>
    );
  }
}

export default App;
